import React, { useState } from "react";
import { motion } from "framer-motion";
import { fadeIn } from "../utils/variants";
import { LazyLoadImage } from "react-lazy-load-image-component";

function EventVideoSection() {
  const [videoLoaded, setVideoLoaded] = useState(false);

  return (
    <div className="flex max-lg:px-6 max-lg:flex-col max-lg:gap-6 h-fit py-14 items-center md:mt-14 mt-10 border-black border-t-4 border-b-2">
      {/* Video Section with Lazy Loading */}
      <motion.div
        variants={fadeIn("left", 0.2)}
        initial="hidden"
        whileInView="show"
        viewport={{ once: false, amount: 0.4 }}
        className="w-[45%] max-lg:w-full flex items-center justify-center"
      >
        {!videoLoaded ? (
          <div
            className="relative w-[620px] h-[380px] max-[1024px]:w-[500px] max-[1024px]:h-[300px] max-md:w-[90%] max-md:h-[260px] max-sm:w-full max-sm:h-[200px] cursor-pointer rounded-3xl overflow-hidden shadow-nottailwindvideo"
            onClick={() => setVideoLoaded(true)}
          >
            <LazyLoadImage
              src="https://img.youtube.com/vi/qZg9CDniGKs/hqdefault.jpg"
              alt="ATC Africa Event Thumbnail"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center">
              <svg
                className="w-16 h-16 max-sm:w-10 max-sm:h-10 text-white"
                fill="currentColor"
                viewBox="0 0 24 24"
              >
                <path d="M7 6v12l10-6z"></path>
              </svg>
            </div>
          </div>
        ) : (
          <iframe
            className="shadow-nottailwindvideo rounded-3xl w-[500px] h-[280px] max-[1024px]:w-[420px] max-[1024px]:h-[250px] max-md:w-[90%] max-md:h-[260px] max-sm:w-full max-sm:h-[200px]"
            src="https://www.youtube.com/embed/qZg9CDniGKs?autoplay=1&rel=0&modestbranding=1"
            title="ATC Africa is Making an IMPACT"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
          ></iframe>
        )}
      </motion.div>

      {/* Text Section */}
      <motion.div
        variants={fadeIn("right", 0.2)}
        initial="hidden"
        whileInView="show"
        viewport={{ once: false, amount: 0.3 }}
        className="flex flex-col gap-8 w-[45%] max-lg:w-full h-full items-center justify-center p-4 max-lg:text-left"
      >
        <h2 className="text-4xl max-[1024px]:text-3xl max-md:text-xl max-sm:text-lg leading-[1.4] tracking-wide font-semibold">
          This annual ATC Africa event empowers young African tech talent by
          fostering knowledge exchange and capacity building in Africa.
        </h2>
        <p className="font-[300] text-xl max-[1024px]:text-lg max-sm:text-base tracking-[0.06em]">
          By connecting professionals and novices from across the continent,
          TechX Africa strengthens the resilience and growth of Africa's entire
          tech landscape.
        </p>
        <p className="font-[300] text-xl max-[1024px]:text-lg max-sm:text-base tracking-[0.06em]">
          Across the continent, Africa is embracing digital transformation, with
          Nigeria leading the change. This tech surge is empowering individuals
          of all backgrounds—developers, designers, content creators,
          cybersecurity experts, Web3 experts, and more—to fuel Africa's digital
          growth in every sector through TechX Africa.
        </p>
      </motion.div>
    </div>
  );
}

export default EventVideoSection;
